<template>
  <div class="main-area">
    <el-breadcrumb separator=":">
      <el-breadcrumb-item>当前位置</el-breadcrumb-item>
      <el-breadcrumb-item>满意度排行</el-breadcrumb-item>
      <div style="text-align: right"><el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">返回</el-button></div>
    </el-breadcrumb>
    <el-divider content-position="left">{{ typeTitle + searchForm.pj }}星满意度</el-divider>
    <el-table style="width: 100%"
              :data="tableData"
              element-loading-text="数据处理中...请稍等..."
              v-loading="loading">
      <!--序号-->
      <el-table-column label="序号" type="index" width="50" align="center" ></el-table-column>
      <el-table-column label="改厕户姓名" prop="mbrxm" align="center"></el-table-column>
      <el-table-column v-if="dataType==='1'" label="报抽人姓名" prop="bcrxm" align="center">
        <template slot-scope="scope">
          {{scope.row.bcrxm? scope.row.bcrxm:'--' }}
        </template>
      </el-table-column>
      <el-table-column v-else label="报修人姓名" prop="bxrxm" align="center">
        <template slot-scope="scope">
          {{scope.row.bxrxm? scope.row.bxrxm:'--' }}
        </template>
      </el-table-column>
      <el-table-column v-if="dataType==='1'" label="报抽人手机号" prop="bcrsjh" align="center">
        <template slot-scope="scope">
          {{scope.row.bcrsjh? scope.row.bcrsjh:'--' }}
        </template>
      </el-table-column>
      <el-table-column v-else label="报修人手机号" prop="bxrsjh" align="center">
        <template slot-scope="scope">
          {{scope.row.bxrsjh? scope.row.bxrsjh:'--' }}
        </template>
      </el-table-column>
      <el-table-column label="改厕户手机号" prop="mbrsjh" align="center"></el-table-column>
      <el-table-column v-if="dataType==='1'" label="报抽时间" prop="bcsj" align="center" :formatter="formatterTime"></el-table-column>
      <el-table-column v-else label="报修时间" prop="bxsj" align="center" :formatter="formatterTime"></el-table-column>
      <el-table-column prop="pj" label="评价" align="center" width="150px">
        <template slot-scope="scope" >
          <el-rate v-model="scope.row.pj" :allow-half="true"  disabled text-color="#000000" :colors="['#000000', '#000000', '#000000']"></el-rate>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="margin-top-10 margin-bottom-20"
      @size-change="tableSizeChange"
      @current-change="currentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagination.pageSizeList"
      :page-size="pagination.pageSize"
      :layout="pagination.layout"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: "satisfactionTable",
    data () {
      return {
        loading: false,
        dataType: '',
        searchForm: {
          ssqh: '',
          beginTime: '',
          endTime: '',
          pj: ''
        },
        // 分页参数
        pagination: {
          pageSizeList: [10, 20, 30, 40, 50],
          pageSize: 10,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          currentPage: 1
        },
        tableData: [],
        typeTitle: '',
        pjLevel: ''
      }
    },
    created() {
      this.dataType = this.$route.params.dataType
      this.searchForm.ssqh = this.$route.params.ssqh
      this.searchForm.beginTime = this.$route.params.beginTime
      this.searchForm.endTime = this.$route.params.endTime
      this.searchForm.pj = this.$route.params.pj.toString()
      if (this.dataType === '1') {
        this.typeTitle = '报抽'
      } else {
        this.typeTitle = '报修'
      }
      this.init()
    },
    methods: {
      init (initPageFlag) {
        this.loading = true
        let _this = this
        let info = {
          baseService: this.dataType === '1'?'TGcBcxxServiceImpl':'TGcBxxxServiceImpl',
          current: initPageFlag ? 1 : this.pagination.currentPage,
          size: initPageFlag ? 10 : this.pagination.pageSize,
          records: [this.searchForm]
        }
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
          _this.dataType === '1'?'myDbCpage':'myDpage', // 业务模块类型 1报抽 2报修
          info, //
          null,
          resultData => {
            _this.loading = false
            if (resultData) {
              if (resultData.code === '200') {
                // 结果参数赋值
                _this.pagination.pageSize = resultData.obj.size
                _this.pagination.total = resultData.obj.total
                _this.pagination.currentPage = resultData.obj.current
                _this.tableData = resultData.obj.records
              }
            } else {
              _this.$message.warning('获取列表数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
      // 获取列表
      getTableData (initPageFlag) {},
      // 分页方法
      tableSizeChange (pageSize) {
        this.pagination.pageSize = pageSize
        this.init()
      },
      currentChange (current) {
        this.pagination.currentPage = current
        this.init()
      },
      goBack: function () {
        this.$router.go(-1)
      },
      formatterTim (row, column, data) {
        if (!data) {
          return ''
        }
        var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
        return data.replace(reg, '$1-$2-$3 $4:$5:$6')
      },
      formatterTime (row, column, data) {
        if (!data) {
          return '-'
        }
        var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
        return data.replace(reg, '$1-$2-$3 $4:$5:$6')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/statistics/satisfactionTable.vue